export default __webpack_public_path__ + "static/Tapetsering6-7ad0d1ad1a23176d72227b0ebfc5e8a7.jpg";